import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Input, Row, Space, Table, Tooltip, Popconfirm, message, Pagination } from 'antd';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { useDispatch, useSelector } from 'react-redux';
import { fetchArchivedGroupsList, resetUserGroupList, unArchiveUserGroup } from '../../slices/user-group';


export default function ArchiveUserGroupList() {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const rowSelection = {
        selectedRowKeys,
        onChange: selectedRowKeys => {
            setSelectedRowKeys(selectedRowKeys);
        },
    };

    const dispatch = useDispatch();
    const { list, totalRecord, status } = useSelector((state) => state.userGroup);
    const [search, setSearch] = useState('');
    const [orderBy, setOrderBy] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);

    useEffect(() => {
        dispatch(resetUserGroupList());
        dispatch(fetchArchivedGroupsList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }));
    }, [page, pagesize, search, orderBy]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const resetFilter = () => {
        setSearch('');
        setOrderBy('');
        setPage(1);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";

        if (sortField === "name" && sortOrder === "ascend") {
            sortingEnumKey = "name";
        }
        if (sortField === "name" && sortOrder === "descend") {
            sortingEnumKey = "-name";
        }
        return sortingEnumKey;
    };

    const handleTableChange = async (pagination, sorter) => {
        const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
        setPageSize(pagination.pageSize);
        setOrderBy(orderBy);
    };

    const handleRestore = (id) => {
        if (!id) {
            message.error('Missing ID for deletion!');
            return;
        }
        dispatch(unArchiveUserGroup(id))
            .unwrap()
            .then(() => {
                message.success('Group Unarchived Successfully!');
            })
            .catch((error) => {
                if (typeof error === 'object' && error !== null) {
                    const messages = [];
                    for (const key in error) {
                        if (Array.isArray(error[key])) {
                            messages.push(`${key}: ${error[key].join(', ')}`);
                        }
                    }
                    if (messages.length > 0) {
                        message.error(messages.join('; '));
                    } else {
                        message.error('An unknown error occurred.');
                    }
                } else if (typeof error === 'string') {
                    message.error(error); // Handle string error
                } else if (error instanceof Error) {
                    message.error(error.message); // Handle Error object
                } else {
                    message.error('An unknown error occurred.');
                }
            });
    };

    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'id',
            key: 'id',
            render: (text, record, index) => (page - 1) * pagesize + index + 1,
            sorter: false,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Action',
            dataIndex: 'id', // Use `id` here for proper alignment and access
            key: 'action',
            render: (text, record) => (
                <Space>
                    <Tooltip placement="top" title={"Unarchive"}>
                        <Popconfirm
                            title="Are you sure you want to Unarchive this record?"
                            onConfirm={() => handleRestore(record.id)} // Correctly access `id`
                            onCancel={() => message.info('Action cancelled')}
                            okText="Yes"
                            cancelText="No"
                        >
                            <ArchiveRestore className="ArchiverestorImg" />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];

    
  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };


    return (
        <div>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2 style={{ margin: 0 }}>Archive Groups</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/manage-user-group" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/dashboard">Home</Link> },
                                    { title: <Link to="/manage-user-group">Groups</Link> },
                                    { title: 'Archive Groups' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="small" >
                            <Input
                                placeholder="Search"
                  className='searchbox'
                                prefix={<SearchOutlined />}
                                value={search}
                                onChange={handleSearch}
                                style={{ width: 200 }}
                            />
                            <Tooltip placement="top" title="Reset Filter">
                                <Button type="primary" disabled={!search && !orderBy} className='iconlink' onClick={resetFilter}>
                                    <FilterIcon />
                                </Button>
                            </Tooltip>
                        </Space>
                    </Col>
                </Row>
            </div>
           <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
                <Table
                    dataSource={list}
                    columns={columns}
                    rowSelection={rowSelection}
                    loading={status === 'loading'}
                    pagination={false}
                    onChange={handleTableChange}
                    className="mt-5"
                    scroll={{
                        x: 1500, // Horizontal Scroll
                        y: 400,  // Vertical Scroll with Fixed Header
                    }}
                />
                   </div>
                        <div
                          style={{
                            position: 'sticky',
                            bottom: 0,
                            zIndex: 1000,
                            background: '#fff',
                            padding: 10,
                            display: 'flex',
                            justifyContent: 'flex-end',
                          }}
                        >
                          <Pagination
                            current={page}
                            pageSize={pagesize}
                            total={totalRecord}
                            showSizeChanger
                            onShowSizeChange={handlePageSizeChange}
                            showTotal={total => `Total ${total} items`}
                            onChange={handlePageChange}
                            locale={{ items_per_page: 'Items / Page' }}
                          />
                        </div>
            </div>
        </div>
    );
}
